/**
 * Checks if a string is a valid HTTP or HTTPS URL
 *
 * This function validates that a string is a properly formatted URL with either
 * http or https protocol. It uses the is-url npm package for validation and adds
 * additional checks for protocol.
 *
 * @param str - The string to check
 * @returns True if the string is a valid HTTP or HTTPS URL, false otherwise
 *
 * @example
 * // Returns true
 * isUrl("https://example.com");
 *
 * @example
 * // Returns false (missing protocol)
 * isUrl("example.com");
 *
 * @example
 * // Returns false (unsupported protocol)
 * isUrl("ftp://example.com");
 */

import isUrlPkg from "is-url";

export function isUrl(str: string): boolean {
    if (str.match(/^https?:[^/]/)) {
        return false;
    }

    try {
        const url = new URL(str);
        return (url.protocol === "http:" || url.protocol === "https:") && url.hostname !== "";
    } catch {
        if (!isUrlPkg(str)) {
            return false;
        }

        try {
            const encodedStr = str.replace(/ /g, "%20");
            const url = new URL(encodedStr);
            return (url.protocol === "http:" || url.protocol === "https:") && url.hostname !== "";
        } catch {
            return false;
        }
    }
}
